module.exports = __webpack_public_path__ + "static/img/serve4.2b73f8dd.png";